export default __webpack_public_path__ + "static/media/pw-add-form-2.99d80856.jpg";